<template>
    <div class="inline">
        <button name="disclaimer" @click="open = true" type="button" class="focus:outline-none">
            <span class="underline text-gray-500 hover:text-gray-700">Advertiser Disclosure</span>
        </button>

        <TransitionRoot as="template" :show="open">
            <Dialog as="div" class="fixed z-50 inset-0 overflow-y-auto" @close="open = false">
                <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                        <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                    </TransitionChild>

                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-6 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                            <div class="absolute top-0 right-0 pt-4 pr-4">
                                <button type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none" @click="open = false">
                                    <span class="sr-only">Close</span>
                                    <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                                </button>
                            </div>

                            <div class="mt-3 sm:mt-0">
                                <DialogTitle as="h3" class="mt-6 sm:mt-2 text-xl leading-6 font-bold text-gray-800 sm:ml-4 text-center sm:text-left">
                                    Disclaimer
                                </DialogTitle>
                            </div>

                            <div class="mt-6 mb-4 mx-5 sm:mx-4 prose text-gray-500" @click="open = false">
                                We receive compensation from certain companies whose products are displayed on this website. As a result, we receive payment when you purchase products through the links on this website. This website is owned and operated by the same company that has ownership interest in certain products featured on this website. This compensation and our ownership interest may affect how and where products appear on the website, including the order in which they appear. This website does not include or rate all products in each category.
                            </div>

                            <div class="mt-5 sm:mt-6">
                                <button type="button" class="inline-flex w-full justify-center rounded-md border border-transparent bg-logo-blue px-4 py-2 font-medium text-white shadow-sm hover:bg-logo-blue-darker focus:outline-none sm:text-sm" @click="open = false">Go back to page</button>
                            </div>
                        </div>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>
    </div>
</template>

<script>
    import { ref } from 'vue'
    import {
        Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    } from '@headlessui/vue'
    import {
        XMarkIcon,
    } from '@heroicons/vue/24/outline'

    export default {
        components: {
            Dialog,
            DialogOverlay,
            DialogTitle,
            TransitionChild,
            TransitionRoot,
            XMarkIcon,
        },

        setup() {
            const open = ref(false)

            return {
                open,
            }
        },
    }
</script>